import { useSelector } from 'react-redux';
var ArticleContact = function ArticleContact(_ref) {
  var _ref$projectIcons = _ref.projectIcons,
    projectIcons = _ref$projectIcons === void 0 ? [] : _ref$projectIcons;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  if (!projectIcons || projectIcons.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", null, projectIcons.map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "a-icons",
      key: x._id
    }, /*#__PURE__*/React.createElement("img", {
      src: "".concat(bucket, "/").concat(x.iconID.filename)
    }), /*#__PURE__*/React.createElement("div", {
      className: "a-icons__tool-tip"
    }, x.iconID.title, /*#__PURE__*/React.createElement("div", {
      className: "a-icons__tool-tip--arrow"
    })));
  }));
};
export default ArticleContact;